module.exports = __webpack_public_path__ + "static/media/question-mark.5c747f9f.png";